
const state = {
  credit_note_id: null,
  description: '',
  id: null,
  price: 0,
  quantity: 1,
}

export const requiredFields = [
  { key: 'description' },
  { key: 'price' },
]

export default state
